import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    templateUrl: './confirmation-modal.html',
    standalone: false
})
export class ConfirmationModalComponent {
  text: string;
  textClassAlign: string;
  subtext: string;
  alternativeIcon: boolean = false;
  textColor: Array<number> = [0,0,0];

  constructor(public dialogRef: MatDialogRef<ConfirmationModalComponent>, @Inject(MAT_DIALOG_DATA) data: any) {
    this.text = data.text;
    this.textClassAlign = data.textClassAlign;
    this.subtext = data.subtext;
    this.alternativeIcon = data.alternativeIcon;
    this.textColor = data.textColor;
  }
}
